import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  closeDate: '',
  entry_id: 0,
  activeStep: 0,
  user_name: '',
  office: '',
  phone: '',
  phoneHelperText: '',
  phoneError: false,
  employee_no: '',
  bingo_mass: [['', '', '', '', ''], ['', '', '', '', ''], ['', '', '', '', ''], ['', '', '', '', ''], ['', '', '', '', '']],
  bingo_massError: '',
  openDate: '',
};

export const entrySlice = createSlice({
  name: 'entry',
  initialState,
  reducers: {
    change: (state, action) => {
      let name = action.payload.name;
      if (name.startsWith('bingo_massCell_')) {
        state.bingo_mass[action.payload.bingo_massRowIndex][action.payload.bingo_massCellIndex] = action.payload.value;
      } else {
        state[name] = action.payload.value;
      }
    },
    next: (state, action) => {
      state.activeStep = action.payload + 1;
    },
    back: (state, action) => {
      state.activeStep = action.payload - 1;
    },
    reset: (state, action) => {
      for (let key in state) {
        if (key !== 'closeDate' && key !== 'openDate')
          state[key] = initialState[key];
      }
    },
    setQueryResult: (state, action) => {
      let queryResult = action.payload;
      for (let key in queryResult) {
        if (key === 'entry_id') {
          state[key] = queryResult[key];
        }
        if (key.startsWith('bingo_mass_')) {
          state.bingo_mass[key.charAt(key.length - 2)][key.charAt(key.length - 1)] = queryResult[key];
        }
      }
    },
    updateDate: (state, action) => {
      state.closeDate = action.payload.closeDate
      state.openDate = action.payload.openDate
    },
  },
});

export const { change, next, back, reset, setQueryResult, updateDate, } = entrySlice.actions;

export default entrySlice.reducer;